import { render, staticRenderFns } from "./requisition-form.vue?vue&type=template&id=5fae47d4"
import script from "./requisition-form.vue?vue&type=script&lang=js"
export * from "./requisition-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports